import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1cc6645c&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=1cc6645c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6645c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cc6645c')) {
      api.createRecord('1cc6645c', component.options)
    } else {
      api.reload('1cc6645c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1cc6645c&scoped=true&", function () {
      api.rerender('1cc6645c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/comment/list.vue"
export default component.exports